import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { Query } from "types";

// Draggable wrapper for QueryTab
export const DraggableQueryTab = ({
  query,
  children,
}: {
  query: Query;
  children: React.ReactNode;
}) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: query.id,
    });

  const handlePointerDown = (event: React.PointerEvent) => {
    // Call the original listener
    if (listeners?.onPointerDown) {
      listeners.onPointerDown(event);
    }
  };

  const handlePointerUp = () => {
    // Pointer up handler - no state to manage
  };

  const handlePointerLeave = () => {
    // Pointer leave handler - no state to manage
  };

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        opacity: isDragging ? 0.5 : 1,
      }
    : {};

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      onPointerDown={handlePointerDown}
      onPointerUp={handlePointerUp}
      onPointerLeave={handlePointerLeave}
      style={style}
      data-testid={`draggable-query-tab-${query.id}`}
    >
      {children}
    </div>
  );
};

export default DraggableQueryTab;
